import { Elements } from "@stripe/react-stripe-js";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import JPContinuePage from "pages/jp/ContinuousPage";
import Footer from "./components/organisms/Footer";
import SecondaryFooter from "components/organisms/SecondaryFooter";
import Header from "./components/organisms/Header";
import SecondaryHeader from "./components/organisms/SecondaryHeader";
import JPCallback from "./pages/jp/Callback";
import JPCardSetup from "./pages/jp/CardSetup";
import JPContinueOrCancelPage from "./pages/jp/ContinueOrCancelPage";
import JPFamilyTrialRegister from "./pages/jp/FamilyTrialRegister";
import JPFinished from "./pages/jp/Finished";
import JPLogin from "./pages/jp/Login";
import JPRegister from "./pages/jp/Register";

import { RecoilRoot } from "recoil";
import { CountryCode, DeployPage, stripePromise } from "./config/BaseConfig";


const JPContinueOrCancelRoutes = () => {
  return (
    <Routes>
      <Route path="/finished" element={<JPFinished />}></Route>
      <Route path="/" element={<JPContinueOrCancelPage />}></Route>
      <Route path="*" element={<JPContinueOrCancelPage />} />
    </Routes>
  );
};

const JPContinueRoutes = () => {
  return (
    <Routes>
      <Route path="/finished" element={<JPFinished />}></Route>
      <Route path="/" element={<JPContinuePage />}></Route>
      <Route path="*" element={<JPContinuePage />} />
    </Routes>
  );
};

const JPRoutes = () => {
  return (
    <Routes>
      <Route path="/payment-setup" element={<JPCardSetup />}></Route>
      <Route path="/finished" element={<JPFinished />}></Route>
      <Route path="/" element={<JPRegister />}></Route>
      <Route path="*" element={<JPRegister />}></Route>
    </Routes>
  );
};

const JPMrFamilyRoutes = () => {
  return (
    <Routes>
      <Route path="/finished" element={<JPFinished />}></Route>
      <Route path="/" element={<JPFamilyTrialRegister />}></Route>
      <Route path="*" element={<JPFamilyTrialRegister />}></Route>
    </Routes>
  );
};

const JPRoutesForTest = () => {
  return (
    <Routes>
      <Route path="/cancel" element={<JPContinueOrCancelPage />}></Route>
      <Route path="/continuous" element={<JPContinuePage />}></Route>
      <Route path="/mr-family" element={<JPFamilyTrialRegister />}></Route>
      <Route path="/payment-setup" element={<JPCardSetup />}></Route>
      <Route path="/finished" element={<JPFinished />}></Route>
      <Route path="/" element={<JPRegister />}></Route>
      <Route path="*" element={<JPRegister />}></Route>
    </Routes>
  );
};

const App = () => {
  return (
    <div id="main_content" style={{ position: "absolute", width: "100%" }}>
      <RecoilRoot>
        <Router basename={"/"}>
          <Routes>
            <Route path="/login" element={<JPLogin />}></Route>
            <Route path="/callback" element={<JPCallback />}></Route>
          </Routes>
        </Router>
        <Router
          basename={
            CountryCode === "JP"
              ? DeployPage === undefined
                ? "/jp/"
                : DeployPage === "APPLICATION_FORM"
                ? "/jp/trial/meetings/"
                : DeployPage === "DOCUMENT_REQUEST_MM"
                ? "/jp/document-request-meeting/"
                : DeployPage === "DOCUMENT_REQUEST_CC"
                ? "/jp/document-request-cc/"
                : DeployPage === "DOCUMENT_REQUEST_RECPOD"
                ? "/jp/document-request-recpod/"
                : DeployPage === "DEMO_REQUEST_CC"
                ? "/jp/demo-request-cc/"
                : DeployPage === "DEMO_REQUEST"
                ? "/jp/demo-request/"
                : DeployPage === "CANCEL_FORM"
                ? "/jp/trial/cancel/"
                : DeployPage === "CONTINUOUS_FORM"
                ? "/jp/trial/continuous/"
                : DeployPage === "MR_FAMILY_FORM"
                ? "/jp/trial/mr-family-00aa26fb4f338603/"
                : "/jp/"
              : "/"
          }
        >
          <Elements stripe={stripePromise}>
            {DeployPage === "APPLICATION_FORM" ||
            DeployPage === "MR_FAMILY_FORM" ||
            DeployPage === undefined ? (
              <SecondaryHeader />
            ) : (
              <Header />
            )}
            {CountryCode === "JP" ? (
              DeployPage === undefined ? (
                <div
                  style={{
                    backgroundColor: "#FFFFFF",
                  }}
                >
                  <JPRoutesForTest />
                </div>
              ) : DeployPage === "CANCEL_FORM" ? (
                <div
                  style={{
                    backgroundColor: "#FFFFFF",
                  }}
                >
                  <JPContinueOrCancelRoutes />
                </div>
              ) : DeployPage === "CONTINUOUS_FORM" ? (
                <div
                  style={{
                    backgroundColor: "#FFFFFF",
                  }}
                >
                  <JPContinueRoutes />
                </div>
              ) : DeployPage === "MR_FAMILY_FORM" ? (
                <div
                  style={{
                    backgroundColor: "#FFFFFF",
                  }}
                >
                  <JPMrFamilyRoutes />
                </div>
              ) : (
                <div
                  style={{
                    backgroundColor: "#FFFFFF",
                  }}
                >
                  <JPRoutes />
                </div>
              )
            ) : null}
            {DeployPage === "APPLICATION_FORM" ||
            DeployPage === "MR_FAMILY_FORM" ||
            DeployPage === undefined ? (
              <SecondaryFooter />
            ) : (
              <Footer />
            )}
          </Elements>
        </Router>
      </RecoilRoot>
    </div>
  );
};

export default App;
